import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M14.918 6.017v4.82a2.614 2.614 0 0 1-2.61 2.62h-1.63v-1.5h1.63a1.116 1.116 0 0 0 1.11-1.12v-4.82a1.116 1.116 0 0 0-1.11-1.12h-3.17a.749.749 0 0 1-.53-.22L7.3 3.377H4.448A1.125 1.125 0 0 0 3.328 4.5v1.7h-1.5V4.5a2.623 2.623 0 0 1 2.62-2.62h3.16a.749.749 0 0 1 .53.22l1.31 1.3h2.86a2.62 2.62 0 0 1 2.61 2.617Zm-5.44 4.17v3.36h-7.64v-5.51h2.14l1.68-1.68 1.68 1.68v2.15Zm-5.5 1.22h-.92v.92h.92Zm0-2.14h-.92v.92h.92Zm2.14 2.14H5.2v.92h.92Zm0-2.14H5.2v.92h.92Zm2.14 2.14h-.92v.92h.92Z';
const draw24px =
  'M18,20.45H15.52V19H18a2.1,2.1,0,0,0,2.1-2.1V9.48A2.1,2.1,0,0,0,18,7.37H13.17a.75.75,0,0,1-.53-.22l-2.12-2.1H6a2.1,2.1,0,0,0-2.1,2.1v2.6H2.39V7.15A3.6,3.6,0,0,1,6,3.55h4.84a.71.71,0,0,1,.53.22l2.12,2.1H18a3.61,3.61,0,0,1,3.6,3.61v7.37A3.6,3.6,0,0,1,18,20.45Zm-7.59-4.61V12.57L7.85,10,5.28,12.57H2V21H13.69V15.84Zm0,3.28v-1.4h1.4v1.4Zm-3.27,0v-1.4h1.4v1.4Zm0-3.28v-1.4h1.4v1.4ZM3.87,19.12v-1.4H5.28v1.4Zm0-3.28v-1.4H5.28v1.4Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const FolderBuildingIcon = forwardRef<
  SVGSVGElement,
  ComponentProps<typeof Icon>
>(generateRenderedIcon(icons, 'folderBuilding')) as IconWithRender;

FolderBuildingIcon.displayName = 'FolderBuildingIcon';
FolderBuildingIcon.propTypes = Icon.propTypes;
FolderBuildingIcon.renderIcon = (props) => <FolderBuildingIcon {...props} />;
export default FolderBuildingIcon;
